module.exports = __webpack_public_path__ + "static/img/certificate_submit.933385b9.png";